import { Controller } from 'stimulus';
import { markerIcon } from '@/helpers/map';

let L;

class MapController extends Controller {
  connect() {
    this.ACCESS_TOKEN = window.app.env.MAPBOX_ACCESS_TOKEN;

    MapController.loadLeaflet()
      .then((module) => {
        L = module.default;

        this.map = this.createMap();
        this.markers = [];
      })
      .then(() => this.addMarkers())
      .then(() => this.addPolylines());
  }

  createMap() {
    const map = L.map(this.mapTarget, {
      center: [39.091919, -94.5757195],
      zoom: 6,
      scrollWheelZoom: false,
    });

    const mapboxTiles = L.tileLayer(`https://api.mapbox.com/styles/v1/lbreizen/cl5jlnh6b000p14mwj6b5rh8g/tiles/{z}/{x}/{y}?access_token=${this.ACCESS_TOKEN}`);

    map.addLayer(mapboxTiles);

    return map;
  }

  addMarkers() {
    if (this.markers.length) {
      this.markers.forEach((marker) => {
        this.map.removeLayer(marker);
      });
    }

    const locations = JSON.parse(this.data.get('locations'));

    locations.forEach((location, i) => {
      const { latitude, longitude } = location;

      if (!latitude || latitude === '' || !longitude || longitude === '') return;

      const marker = L.marker([parseFloat(latitude), parseFloat(longitude)], {
        icon: markerIcon(i === 0),
      }).addTo(this.map);

      this.markers.push(marker);
    });
  }

  addPolylines() {
    const locations = JSON.parse(this.data.get('locations'));

    if (!locations.length) return;

    const coordinates = locations.map((location) => [
      parseFloat(location.latitude),
      parseFloat(location.longitude),
    ]);

    const polyline = L.polyline(coordinates, {
      color: '#8238f2',
      dashArray: '5',
    }).addTo(this.map);

    this.map.fitBounds(polyline.getBounds(), {
      padding: [15, 15],
    });
  }

  static loadLeaflet() {
    return new Promise((resolve, reject) => {
      import(/* webpackChunkName: "leaflet" */ '../vendor/leaflet')
        .then(resolve)
        .catch(reject);
    });
  }
}

MapController.targets = [
  'map',
];

export default MapController;
